import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';
import { captureAndStoreUTM } from '../utils/utmCapture';

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Capture UTM parameters on any route change (global capture)
    // This ensures UTM params are captured regardless of entry point
    captureAndStoreUTM();
    
    // Track page view on route change
    const pageTitles = {
      '/': 'Home',
      '/dashboard': 'Dashboard',
      '/login': 'Login',
      '/register': 'Register',
      '/pricing': 'Pricing',
      '/settings': 'Settings',
      '/backups': 'Backup Progress',
      '/help': 'Help Center',
      '/contact': 'Contact',
      '/privacy': 'Privacy Policy',
      '/terms': 'Terms of Service',
      '/status': 'Status',
      '/admin': 'Admin Dashboard',
    };

    const pageTitle = pageTitles[location.pathname] || location.pathname;
    trackPageView(location.pathname, pageTitle);
  }, [location]);

  return null; // This component doesn't render anything
};

export default RouteTracker;
